import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const personnelTrainingApi = {
    getPersonnelTrainingById: (id: number): Observable<Dtos.GetPersonnelTrainingByIdResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelTrainingById = new Dtos.GetPersonnelTrainingById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetPersonnelTrainingByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getPersonnelTrainingByPersonnelId: (personnelId: number): Observable<Dtos.GetPersonnelTrainingByPersonnelIdResponse> => {
        //Create the request.
        let request: Dtos.GetPersonnelTrainingByPersonnelId = new Dtos.GetPersonnelTrainingByPersonnelId();

        request.personnelId = personnelId;

        //Send request.
        const response: Promise<Dtos.GetPersonnelTrainingByPersonnelIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    createPersonnelTraining: (personnelId: number): Observable<Dtos.CreatePersonnelTrainingResponse> => {
        //Create the request.
        let request: Dtos.CreatePersonnelTraining = new Dtos.CreatePersonnelTraining();

        request.personnelId = personnelId;

        //Send request.
        const response: Promise<Dtos.CreatePersonnelTrainingResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setPersonnelTraining: (personnelTraining: Dtos.PersonnelTraining): Observable<Dtos.SetPersonnelTrainingResponse> => {

        let request: Dtos.SetPersonnelTraining = new Dtos.SetPersonnelTraining();

        request.personnelTraining = personnelTraining;

        // send request
        const response: Promise<Dtos.SetPersonnelTrainingResponse> = client.post(request);

        return Observable.from(response);
    },
    validatePersonnelTraining: (personnelTraining: Dtos.PersonnelTraining): Observable<Dtos.ValidatePersonnelTrainingResponse> => {

        let request: Dtos.ValidatePersonnelTraining = new Dtos.ValidatePersonnelTraining();

        request.personnelTraining = personnelTraining;

        // send request
        const response: Promise<Dtos.ValidatePersonnelTrainingResponse> = client.post(request);

        return Observable.from(response);
    }
}